import { logger } from 'monitor';
import { memo } from 'react';
import { Box, CircularProgress, styled } from 'ui';

export const VideoFeed = styled('video')<NonNullable<unknown>>(() => ({
  display: 'block',
  height: '100%',
  margin: 'auto',
  objectFit: 'fill',
  width: '100%',
}));

const LoadingContainer = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
});

const VideoComponent = ({ stream, isLoading }: { stream: MediaStream | null; isLoading: boolean }) => {
  logger.info('Camera device settings: ', stream?.getVideoTracks()[0].getSettings());

  if (isLoading) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }
  return (
    <VideoFeed
      autoPlay
      playsInline
      muted
      ref={(video) => {
        if (video && stream) {
          video.srcObject = stream;
        }
      }}
    />
  );
};

export const Video = memo(VideoComponent);
